/** App flow timing (ms) */
export const TERMINAL_DURATION = 4000
export const APPLICATION_EXPAND_DELAY = 1000
export const APPLICATION_REDIRECT_DELAY = 600

/** Terminal typing simulation */
export const TERMINAL_CONFIG = {
  COMMAND: './wedding-app',
  PROMPT_DELAY_MS: 800,
  TYPING_DELAY_MIN: 20,
  TYPING_DELAY_MAX: 90,
  OUTPUT_DELAY_MS: 1000,
}

export const TERMINAL_OUTPUT_LINES = [
  'debug: starting application',
  'debug: loading webview',
  'debug: webview loaded',
]

/** Wedding data */
export const WEDDING_DATE = '2026-06-06T16:00:00'

export const DRESSCODE_PALETTE = [
  { color: '#9bb7d4', title: 'Cerulean 15-4020 TCX' },
  { color: '#b8a9c4', title: 'Chalk Violet 17-3615 TCX' },
  { color: '#e8c4c0', title: '2446 CP' },
  { color: '#e8c9a8', title: '4009 UP' },
  { color: '#9a9f5c', title: 'Golden Cypress 18-0537 TCX' },
  { color: '#1e3f63', title: 'Blueberry Pancake 19-4119 TSX' },
  { color: '#4a3d6b', title: 'Indigo 19-3215 TCX' },
  { color: '#a62d5c', title: 'Vivacious 19-2045 TCX' },
  { color: '#a65c3a', title: 'Rooibos Tea 18-1355 TCX' },
  { color: '#1e3d2e', title: 'Forest Elf 19-0231 TCX' },
]

export const PROGRAM_STEPS = [
  { time: '15:00', title: 'Регистрация гостей' },
  { time: '16:00', title: 'Церемония' },
  { time: '17:00', title: 'Банкетный ужин' },
  { time: '19:00', title: 'Вечеринка' },
  { time: '23:00', title: 'Завершение вечера' },
]

/** Склоняемые подписи для обратного отсчёта: one (1), few (2-4), many (5+) */
export const COUNTDOWN_LABELS = {
  months: { one: 'месяц', few: 'месяца', many: 'месяцев' },
  days: { one: 'день', few: 'дня', many: 'дней' },
  hours: { one: 'час', few: 'часа', many: 'часов' },
}

export function pluralizeRussian(n, forms) {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return forms.one
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return forms.few
  return forms.many
}

/** Yandex Maps JS API 3.0 — requires VITE_YANDEX_MAPS_API_KEY in .env */
export const YANDEX_MAP_API_URL =
  import.meta.env.DEV
    ? '/yandex-maps-api/v3/'
    : 'https://api-maps.yandex.ru/v3/'
export const YANDEX_MAP_CUSTOMIZATION_URL = '/customization.json'

/** Fallback: Constructor API (no customization, no API key) */
const CONSTRUCTOR_PARAMS =
  'um=constructor%3Ad61c36698d1e0ed10c0bf5f4d62d79ccdcd0c45cd88f1fa3cccbdf0c409c2f3c&width=100%25&height=720&lang=ru_RU'
export const YANDEX_MAP_CONSTRUCTOR_URL =
  import.meta.env.DEV
    ? `/yandex-constructor/?${CONSTRUCTOR_PARAMS}`
    : `https://api-maps.yandex.ru/services/constructor/1.0/js/?${CONSTRUCTOR_PARAMS}`

/** Map center: [longitude, latitude] */
export const MAP_CENTER = { center: [37.717536, 56.074255], zoom: 16 }
